import { type ReactNode } from 'react';
import { HEADING_TAGS } from '../../constants/common';
import { type TypographyType } from '../../types/common';
import { Text } from './typography.styled';

export interface HeadingType {
  variant: TypographyType;
  icon?: string | ReactNode;
  title: string | number | ReactNode;
  className?: string;
  disabled?: boolean;
  color?: string;
  fontWeight?: 400 | 500 | 600 | 700;
  onClick?: any;
  style?: React.CSSProperties;
  id?: string;
}

const Heading = ({
  variant,
  icon,
  title,
  className,
  disabled,
  color,
  fontWeight,
  onClick,
  style,
  id,
  ...rest
}: HeadingType): JSX.Element => {
  const textTag = HEADING_TAGS.includes(variant) ? variant : 'span';
  return (
    <Text
      id={id}
      className={className}
      variant={variant}
      as={textTag}
      color={color}
      fontWeight={fontWeight}
      onClick={onClick}
      style={style}
      {...rest}>
      {icon}
      {title}
    </Text>
  );
};

export default Heading;
